import { handleApiCall } from "./Interactor";
import { format } from "date-fns";

export const getServiceDetails = (serviceId, onSuccessView, onFailedView) => {
  // https://staging.walletkuportal.com:1998/api/v3/services/75?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  handleApiCall(
    "GET",
    process.env.REACT_APP_VENUE_V5 +"/"+ serviceId + "/detail", {},
    (responseJSON) => {
      //dispatch response json to redux
    },
    onSuccessView,
    onFailedView
  )

}

export const getServiceSchedule = (serviceId, packageId, date, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/services/show_available_times?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  var params = {
    service_id: serviceId,
    service_package_id: packageId,
    date_available: date
  }
  handleApiCall(
    "POST",
    process.env.REACT_APP_GET_SERVICE_SCHEDULE + "?authToken=" + authToken,
    params,
    (responseJSON) => {
      //dispatch response json to redux

    },
    onSuccessView,
    onFailedView
  )

}

export const getServiceMonthlySchedule = (serviceId, packageId, month, year, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/services/show_available_times_by_month_and_year?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  var params = {
    service_id: serviceId,
    service_package_id: packageId,
    month: month,
    year: year
  }
  handleApiCall(
    "POST",
    process.env.REACT_APP_GET_SERVICE_MONTHLY_SCHEDULE + "?authToken=" + authToken,
    params,
    (responseJSON) => {
      //dispatch response json to redux

    },
    onSuccessView,
    onFailedView
  )

}

export const getListService = (search, sport_type, sort_by, sort_direction, page, onSuccessView, onFailedView) => {
  handleApiCall(
    "GET",
    process.env.REACT_APP_VENUE_V5 + "/for_user"
    + "?sort_direction=" + sort_direction
    + "&page=" + page
    + "&search=" + search
    + "&sport_type=" + sport_type
    + "&sort_by=" + sort_by,
    {},
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )

}

export const getListAddon = (id, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/add_on_items?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  handleApiCall(
    "POST",
    process.env.REACT_APP_GET_ADDON_LIST_V5 + "?authToken=" + authToken, {
    user_admin_id: id
  },
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )
}

export const getListPaymentMethod = (phone_number, total, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/faspay/channel?total_payment=10000&auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  handleApiCall(
    "GET",
    process.env.REACT_APP_GET_PAYMENT_METHOD_LIST_V3 + "?total_payment=" + total + "&phone_number=" + phone_number + "&authToken=" + authToken, {},
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )

}

export const checkoutBooking = (data, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/service_member_books
  var authToken = process.env.REACT_APP_AUTH_TOKEN;

  let addons = data.addons.map(addon => (
    {
      add_on_item_id: addon.id,
      price: addon.price,
      qty: addon.qty,
      qty_hour: addon.unit !== "Hour" ? 1 : data.selected_schedule.length,
      total: (addon.price * addon.qty * (data.selected_schedule.length))
    }
  ));

  let bookingTimes = data.selected_schedule.map(time => (
    {
      service_id: data.venue.id,
      service_time_id: time.service_time_id,
      service_date: format(data.selected_date, 'yyyy-MM-dd'),
      start_time: time.hour.split(" - ")[0],
      end_time: time.hour.split(" - ")[1],
      price: time.price,
      // promo_price: time.promo_price
    }
  ));

  let transactions = [];
  transactions.push(
    {
      community_id: 0,
      payment_with: 'faspay',
      pg_code: data.paymentMethod.pg_code,
      pg_name: data.paymentMethod.pg_name,
      package_unit: 'Sesi',
      qty: data.selected_schedule.length,
      package_price: 0,
      // subtotal: data.subtotal,
      discount: data.discount,
      promo_id: data.paymentMethod.promo_id,
      pg_discount: data.paymentMethod.discount_amount,
      service_fee: data.service_fee,
      admin_fee: data.paymentMethod.admin_fee,
      total: data.total + data.discount - data.service_fee - data.paymentMethod.discount_amount,
      is_dp: 0
    }
  );

  let params = {
    service_member_book: {
      service_id: data.venue.id,
      member_id: 0,
      service_package_id: 0,
      service_date: format(data.selected_date, 'yyyy-MM-dd'),
      contact_name: data.contact.name,
      contact_phone: data.contact.phone,
      contact_email: data.contact.email,
      total_payment: data.total + data.paymentMethod.admin_fee - data.paymentMethod.discount_amount,
      total_dp: 0,
      booking_times_attributes: bookingTimes,
      add_on_item_service_member_books_attributes: addons,
      transaction_services_attributes: transactions
    }
  }

  handleApiCall('POST', process.env.REACT_APP_CHECKOUT_V5,
    params,
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView)
}

export const checkReview = (bookingID, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/service_ratings/check_review?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  var params = {
    order_id: bookingID
  }
  handleApiCall(
    "POST",
    process.env.REACT_APP_CHECK_REVIEW + "?authToken=" + authToken,
    params,
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )
}

export const submitReview = (data, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/service_ratings?auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  var params = {
    service_rating: {
      service_member_book_id: data.bookingID,
      service_id: data.serviceId,
      venue_condition: data.ratingLapang,
      clean: data.ratingKebersihan,
      facilities: data.ratingFasilitas,
      security: data.ratingKeamanan,
      transportation_access:
        data.ratingAkses,
      description: data.review,
      hide_name: data.isAnonymous
    }
  }
  handleApiCall(
    "POST",
    process.env.REACT_APP_SUBMIT_REVIEW + "?authToken=" + authToken,
    params,
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )
}

export const getListReviews = ({ venueId, page }, onSuccessView, onFailedView) => {
  // http://staging.walletkuportal.com:1993/api/v3/faspay/channel?total_payment=10000&auth_token=x-yFPT_sQw2FQDqv3Abu
  var authToken = process.env.REACT_APP_AUTH_TOKEN;
  handleApiCall(
    "GET",
    process.env.REACT_APP_GET_REVIEW_LIST + "?service_id=" + venueId + "&page=" + page + "&authToken=" + authToken, {},
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )
}

export const getServiceDailySchedule = (serviceId, date_available, onSuccessView, onFailedView) => {
  const getDayName = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID', { weekday: 'long' });
  };
  const dayName = getDayName(date_available);
  var params = {
    service_id: serviceId,
    day: dayName,
    date_available: format(date_available, 'yyyy-MM-dd')
  }
  handleApiCall(
    "POST",
    process.env.REACT_APP_GET_SERVICE_DAILY_SCHEDULE_V5,
    params,
    (responseJSON) => {

    },
    onSuccessView,
    onFailedView
  )

}